import React,{useState,useEffect} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link,useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import { Typography } from "@material-ui/core";
import { clearErrors, getOrderDetails } from "../actions/orderAction";
import Loader from "./Loader";
import MetaData from '../components/MetaData.js';
import {setCache,getCache} from './cache.js';

const OrderDetails = () => {

	const { order, error, loading } = useSelector((state) => state.orderDetails);

	const dispatch = useDispatch();
	const {id} = useParams();
  	const alert = useAlert();

  	useEffect(() => {
	    if (error) {
	      alert.error(error);
	      dispatch(clearErrors());
	    }

	    dispatch(getOrderDetails(id));
	}, [dispatch, alert, error, id]);

	const [currencySymbol, setCurrencySymbol] = useState("£");
  const [countryCode, setCountryCode] = useState("GB");
  const [isLoading, setIsLoading] = useState(false);

  // Country-to-Currency mapping with exchange rates
  // const countryToCurrency = {
  //   PK: { symbol: "₨", rate: 380 },
  //   US: { symbol: "$", rate: 1.2 },
  //   FR: { symbol: "€", rate: 1.15 },
  //   IN: { symbol: "₹", rate: 100 },
  //   GB: { symbol: "£", rate: 1 },
  // };

  const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

  //   const fetchExchangeRates = async () => {
  //     try {
  //       const response = await fetch(API_URL);
  //       if (!response.ok) throw new Error("Failed to fetch exchange rates");
  //       const data = await response.json();

  //       setCountryToCurrency((prev) => {
  //         const updatedCurrencies = { ...prev };

  //         Object.keys(updatedCurrencies).forEach((country) => {
  //           const currencyCode = updatedCurrencies[country].currencyCode;
  //           const rate = data.rates[currencyCode];
  //           if (rate) {
  //             updatedCurrencies[country].rate = rate;
  //           }
  //         });

  //         return updatedCurrencies;
  //       });
  //     } catch (error) {
  //       console.error("Error fetching exchange rates:", error);
  //     }
  //   };

  //   // Fetch user's country using their IP address
  //   const fetchUserCountry = async () => {
  //   try {
  //     const response = await fetch("https://get.geojs.io/v1/ip/country.json");
  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  //     const data = await response.json();
  //     return data.country || "GB";
  //   } catch (error) {
  //     console.error("Error fetching user country:", error);
  //     return "GB"; // Default to GB on failure
  //   }
  // };


  //   const loadCurrencyDetails = async () => {
  //   setIsLoading(true);
  //   await fetchExchangeRates();
  //   const userCountry = await fetchUserCountry();
  //   setCountryCode(userCountry);
  //   // Use updated rates
  // setCountryToCurrency((prev) => {
  //   const currencyInfo = prev[userCountry] || prev["GB"]; // Default to GBP if country not found
  //   setCurrencySymbol(currencyInfo.symbol || "£");
  //   return prev;
  // });
  //   setIsLoading(false);
  // };

  // useEffect(() => {
  //   loadCurrencyDetails();
  // }, []);

    const CACHE_DURATION = 1 * 10;

    const fetchExchangeRates = async () => {
  const cacheKey = `ExchangeRates:${new Date().toISOString().split('T')[0]}`;
  console.log(`[FETCH] Generated Cache Key: ${cacheKey}`);
  const cachedData = getCache(cacheKey);
  console.log(cachedData)
  if (cachedData) {
    console.log("Exchange rates fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch(API_URL);
    if (!response.ok) throw new Error("Failed to fetch exchange rates");

    const data = await response.json();
    setCache(cacheKey, data, CACHE_DURATION);
    console.log("Exchange rates fetched from API");
    return data;
  } catch (error) {
    console.error("Error fetching exchange rates:", error);
    throw error;
  }
};

// Fetch user's country with caching
const fetchUserCountry = async () => {
  const cacheKey = "UserCountry";
  const cachedData = getCache(cacheKey);

  if (cachedData) {
    console.log("User country fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch("https://get.geojs.io/v1/ip/country.json");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    const country = data.country || "GB";
    setCache(cacheKey, country, CACHE_DURATION);
    console.log("User country fetched from API");
    return country;
  } catch (error) {
    console.error("Error fetching user country:", error);
    return "GB"; // Default to GB on failure
  }
};

// Load currency details with caching
const loadCurrencyDetails = async () => {
  setIsLoading(true);

  try {
    const exchangeRates = await fetchExchangeRates();
    const userCountry = await fetchUserCountry();

    setCountryToCurrency((prev) => {
      const updatedCurrencies = { ...prev };

      Object.keys(updatedCurrencies).forEach((country) => {
        const currencyCode = updatedCurrencies[country].currencyCode;
        const rate = exchangeRates.rates[currencyCode];
        if (rate) {
          updatedCurrencies[country].rate = rate;
        }
      });

      const currencyInfo = updatedCurrencies[userCountry] || updatedCurrencies["GB"];
      setCurrencySymbol(currencyInfo.symbol || "£");

      return updatedCurrencies;
    });

    setCountryCode(userCountry);
  } catch (error) {
    console.error("Error loading currency details:", error);
  } finally {
    setIsLoading(false);
  }
};

// React useEffect to load data on mount
useEffect(() => {
  loadCurrencyDetails();
}, []);
	
	return (
		<>
			{loading ? (
		        <Loader />
		      ) : (
		      <>

		      	<MetaData title="Order Details" />

		      	<div className="orderDetailsPage">
		      	<div className="container">
		            <div className="orderDetailsContainer">
		              <h3>
		                Order # {order && order._id}
		              </h3>
		              <div className="row pt-5">
			              
			              <div className="col-lg-4 col-md-12 col-sm-12 mb-4">
				              <div className="orderDetailsContainerBox">
				              <h4>Contact Details</h4>
				                <div>
				                  <p><b>Name:</b></p>
				                  <span>{order?.user && order?.user?.name}</span>
				                </div>
				                <div>
				                  <p><b>Phone:</b></p>
				                  <span>
				                    {order?.shippingInfo && order?.shippingInfo?.phoneNo}
				                  </span>
				                </div>
				                <div>
				                  <p><b>Address:</b></p>
				                  <span>
				                    {order?.shippingInfo &&
				                      `${order.shippingInfo?.address}, ${order.shippingInfo?.city}, ${order.shippingInfo?.state}, ${order.shippingInfo?.pinCode}, ${order.shippingInfo?.country}`}
				                  </span>
				                </div>
				              </div>
			              </div>

				           <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
				              <div className="orderDetailsContainerBox">
				              <h4>Payment</h4>
				                <div>
				                  <p
				                    className={
				                      order?.paymentInfo &&
				                      order?.paymentInfo?.status === "succeeded"
				                        ? "greenColor"
				                        : "redColor"
				                    }
				                  >
				                    <b>{order?.paymentInfo &&
				                    order?.paymentInfo?.status === "succeeded"
				                      ? "PAID"
				                      : "NOT PAID"}
				                      </b>
				                  </p>
				                </div>
				                <div>
				                  <p><b>Amount:</b></p>
				                  <span>£{order?.totalPrice && order?.totalPrice}</span>
				                </div>
			               		</div>
		              		</div>

		              		<div className="col-lg-4 col-md-6 col-sm-6 mb-4">
				              <div className="orderDetailsContainerBox">
				              <h4>Order Status</h4>
				                <div>
				                  <p
				                    className={
				                      order?.orderStatus && order?.orderStatus === "Delivered"
				                        ? "greenColor"
				                        : "redColor"
				                    }
				                  >
				                    <b>{order?.orderStatus && order?.orderStatus}</b>
				                  </p>
				                </div>
				              </div>
			                </div>

		              </div>
		            </div>

		            <div className="orderDetailsCartItems">
		              <h4>Order Items:</h4>
		              <div className="orderDetailsCartItemsContainer">
		                {order?.orderItems &&
		                  order?.orderItems.map((item) => {
		                  	const rate = countryToCurrency[countryCode]?.rate || 1;
						    const symbol = countryToCurrency[countryCode]?.symbol || "£";

						    // Calculate the localized item price (base price)
						    const localizedItemPrice = (item.price * rate).toFixed(2);

						    // Calculate the total item price with VAT applied
						    const totalPriceWithVAT = (
						      item.price * item.quantity * (1 + item.vat / 100) * rate
						    ).toFixed(2);

		                  	return(
		                    <div key={item.product}>
		                      <img src={item?.image} alt="Product" />
		                      <Link className="text-capitalize" to={`/product/${item.product}`}>
		                        <b>{item.topic}</b>
		                      </Link>
		                      <span>
		                      {item.quantity} X £{item.price} 
		                      {/*<sub>{symbol} {localizedItemPrice}</sub>*/}
		                       + VAT {item.vat}% =
		                      <b className="mx-1">£{parseFloat((item.price * item.quantity * (1 + item.vat / 100)).toFixed(10))}</b>
		                    </span>
		                      {/*<span>
					          {item.quantity} X {symbol}
					          {localizedItemPrice} + VAT {item.vat}% = 
					          <b className="mx-1">
					            {symbol}
					            {totalPriceWithVAT}
					          </b>
					        </span>*/}
		                    </div>
		                  );
						})}
		              </div>
		            </div>

		        </div>
		        </div>

		      </>
		      )}
		</>
	)
}

export default OrderDetails